import React from "react";
import { BsPersonWorkspace } from "react-icons/bs";
import { educations } from "./educations";
import lottieFile from "./study.json";
import AnimationLottie from "./animation-lottie";
import GlowCard from "./glow-card";
import "./education.css"; // Import the CSS file

function Education() {
  return (
    <div id="education" className="resume container section">
      <h2 className="section__title">Education</h2>
   <div className="education-content">
        <div className="education-grid">
          <div className="lottie-container">
            <AnimationLottie animationPath={lottieFile} />
          </div>

          <div className="education-list">
            {educations.map((education) => (
              <GlowCard key={education.id} identifier={`education-${education.id}`}>
                <div className="education-card">
                  
                  <div className="education-duration">
                    <p>{education.duration}</p>
                  </div>
                  <div className="education-details">
                    <div className="education-icon">
                      <BsPersonWorkspace size={36} />
                    </div>
                    <div>
                      <p className="education-title">{education.title}</p>
                      <p className="education-institution">{education.institution}</p>
                    </div>
                  </div>
                </div>
              </GlowCard>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Education;
